import { initDeliveryOption } from 'modules/checkout/actions.pickup';

import { fetchAnonymousBasket } from 'api/baskets';
import { fetchOrderDetails } from 'api/orders';
import { getPickupAndDeliveryOptions } from 'api/distributions';

export const FETCH_BASKET_REQUEST_SENT = 'FETCH_BASKET_REQUEST_SENT';
export const FETCH_BASKET_SUCCEEDED = 'FETCH_BASKET_SUCCEEDED';
export const UPDATE_BASKET_PRICES = 'UPDATE_BASKET_PRICES';
export const SET_BASKET = 'SET_BASKET';

const fetchBasketRequestSent = () => ({
    type: FETCH_BASKET_REQUEST_SENT,
});

const fetchBasketSucceeded = (basket, deliveryOptions) => ({
    type: FETCH_BASKET_SUCCEEDED,
    basket,
    deliveryOptions,
});

const fetchBasket = (basketId, isAnonymous) => dispatch => {
    dispatch(fetchBasketRequestSent());
    const req = isAnonymous ? fetchAnonymousBasket(basketId) : fetchOrderDetails(basketId);

    return req.then(basket => {
        getPickupAndDeliveryOptions(basket.distribution.id).then(deliveryOptions => {
            dispatch(fetchBasketSucceeded(basket, deliveryOptions));
            dispatch(initDeliveryOption(basket.distributionId, deliveryOptions));
        });
    });
};

export const setBasket = basket => dispatch => {
    dispatch({
        type: SET_BASKET,
        basket,
    });
};

export const fetchBasketIfNeeded = (basketId, isAnonymous) => (dispatch, getState) => {
    const state = getState().checkout;
    if (!state.isFetchingBasket) {
        return dispatch(fetchBasket(basketId, isAnonymous));
    }
    return Promise.resolve();
};
